import { makeSx } from '../../../theme/_utils'

export default makeSx({
    // border is sets on parent, it removes cell border bottom to keep a thin border
    comparisonTableRow: {
        '&:last-child': {
            '.MuiBox-root': {
                borderBottomColor: 'transparent !important',
            },
        },
    },
})
